<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      hide-default-footer
      class="elevation-1"
      :items-per-page="9999"
    >
      <template v-slot:item="props">
        <tr class="cursor-pointer" v-on:click="rowClick(props.item)">
          <td>
            {{ props.item.name }}
          </td>
          <td>
            <div class="text-right">{{ props.item.visit | decimalFormat }}</div>
          </td>
          <td>
            <div class="text-right">{{ props.item.percent_visit }}%</div>
          </td>
        </tr>
      </template>

      <template v-if="items.length === 0" v-slot:body>
        <tbody>
          <tr class="v-data-table__empty-wrapper">
            <td class="text-center" :colspan="5">No data available</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.items = this.item.child.map(o => ({ ...o }))
        if (this.items.length > 0) {
          const total = this.item.visit || 1

          for (const obj of this.items) {
            obj.percent_visit = parseFloat((obj.visit * 100) / total).toFixed(2)
          }
        }
      }
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Next checkpoint',
          value: 'name',
          align: 'start',
          sortable: false,
          width: '80%'
        },
        {
          text: 'Visit',
          value: 'visit',
          align: 'right',
          sortable: false,
          width: '90px'
        },
        {
          text: '%Visit',
          value: 'percent_visit',
          align: 'right',
          sortable: false,
          width: '90px'
        }
      ],
      items: [],
      sortBy: ['visit', 'name'],
      sortDesc: [true, false]
    }
  },
  methods: {
    rowClick(data) {
      this.$emit('nextClick', data.name)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table {
  border: unset !important;
}

::v-deep .v-data-table__wrapper {
  // min-height: 150px !important;
  height: unset !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  height: 37px !important;
  padding: 0 7px !important;
}

.v-data-table > .v-data-table__wrapper > table > thead > .head1 > th {
  border-top: unset !important;
  border-right: unset !important;
  border-left: unset !important;
  background-color: white !important;
}
</style>
